import { StaticFrameModel } from '../Question/StaticFrameModel';
import { Instance, types } from 'mobx-state-tree';

export const SessionStepModel = types.model('SessionStepModel', {
  sessionStepId: types.maybeNull(types.string),
  contentType: types.string,
  order: types.number,
  ownId: types.identifier,
  displayResult: types.maybeNull(types.boolean),
  contentId: types.maybeNull(types.string),
  text: types.maybeNull(types.string),
  endOfSurvey: types.maybeNull(types.boolean),
  skippable: types.maybeNull(types.boolean),
  review: types.maybeNull(types.number),
  survey: types.maybeNull(types.string),
  /** the question set (survey used as a namespace by dynamic questions) a QUESTION/FRAME step belongs to */
  questionSet: types.maybeNull(types.string),
  /** FRAME steps: what the frame shows (layout in `type`) */
  frame: types.maybeNull(StaticFrameModel),
  /** flow identity of the step (tree node key), defaults to its order */
  key: types.maybeNull(types.string),
  myExerciceId: types.maybeNull(types.string),
  exerciseDecided: types.maybeNull(types.boolean),
  answers: types.maybeNull(types.array(types.string)),
  range: types.maybeNull(types.number),
  valueSonar: types.maybeNull(types.number),
  freeText: types.maybeNull(types.string),
  importance: types.maybeNull(types.number),
  userSurvey: types.maybeNull(types.string),
  needTagRefetch: types.maybeNull(types.boolean),
  needImmediateTagRefetch: types.maybeNull(types.boolean),
});

export type ISessionStepModel = Instance<typeof SessionStepModel>;
